<script lang="ts">

    import type { SvelteComponent } from 'svelte';
    import { Modal, ModalBody, ModalHeader, Form, FormGroup, Label, Col, Row } from 'sveltestrap';
    import type { Question } from '../Model/Question';
    import WidthSelect from './WidthSelect.svelte';
    import OptionsManager from './OptionsManager.svelte';
    import QuestionGridManager from './QuestionGridManager.svelte';
    import QuestionTypeLabel from './QuestionTypeLabel.svelte';
    import StateInput from './StateInput.svelte';
    
    export let question: Question = null;

    const toggle = () => open = !open;
    const optionsManagersMap = {
        'bool'              : OptionsManager,
        'multiple'          : OptionsManager,
        'grid'              : QuestionGridManager,
    };
    
    let open = false;
    let optionsManager: typeof SvelteComponent = undefined;

    $: setupComponent(question);

    function setupComponent(question: Question): void {
        if (!question) {
            optionsManager = null;
            open = false;
            return;
        }
        optionsManager = optionsManagersMap[question.type] || undefined;
        open = true;
    }

</script>

<Modal isOpen={open} {toggle} size="lg" on:close>
    <ModalHeader {toggle}>Editar Pregunta (<QuestionTypeLabel type={question.type} />)</ModalHeader>
    <ModalBody>
        <Form id="info">
            <Row class="align-items-end">
                <Col xs="12">
                    <FormGroup>
                        <Label for="tittle">Título</Label>
                        <StateInput type="text" store={question.name} />
                    </FormGroup>
                </Col>
                <!-- <Col md="4">
                    <FormGroup>
                        <Label for="tittle">Ancho de la pregunta</Label>
                        <WidthSelect value={question.width} />
                    </FormGroup>
                </Col> -->
                <Col xs="12">
                    <FormGroup>
                        <StateInput type="checkbox" label="Respuesta obligada" store={question.forced} />
                    </FormGroup>
                    <FormGroup>
                        <StateInput
                            type="checkbox"
                            label="Usar valor en el nombre del informe"
                            store={question.useAnswerInFileName} />
                    </FormGroup>
                </Col>
            </Row>
            <Row>
                <Col>
                    <svelte:component this={optionsManager} bind:options={question.options} />
                </Col>
            </Row>
        </Form>
    </ModalBody>
</Modal>